import * as Sentry from '@sentry/react';
import { env } from '@/lib/config/env';

// Initializes Sentry for frontend error/crash monitoring. No-ops when
// VITE_SENTRY_DSN is unset, mirroring the backend's EnableTracking kill switch.
export function initErrorTracking(): void {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.environment,
    enabled: !!env.sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}
